export const _en = {
    skill: {
        layer: {
            libelle: "Skill"
        },
        buttons: {
            add: {
                human: {
                    label: "Skills"
                },
                material: {
                    label: "Features"
                }
            },
            del: {
                label: "Delete a skill"
            }
        },
        dialog: {
            human: {
                title: "Add new skill on this resource type"
            },
            material: {
                title: "Add new skill on this resource type"
            }
        },
        deletedCheckBox: {
            label: "Display deleted data"
        },
        form: {
            typeResource: {
                placeHolder: "Choose a type"
            }
        },
        advancedFilter: {
            placeholder: {
                human: "Filter skills",
                material: "Filter features "
            }
        }
    }
};

export const _fr = {
    skill: {
        layer: {
            libelle: "Compétences"
        },
        buttons: {
            add: {
                human: {
                    label: "Compétence"
                },
                material: {
                    label: "Caractéristique"
                }
            },
            del: {
                label: "Compétence"
            }
        },
        dialog: {
            add: {
                human: {
                    title: "Ajout d'une compétence"
                },
                material: {
                    title: "Ajout d'une caractéristique"
                }
            }
        },
        deletedCheckBox: {
            label: "Afficher les compétences archivées"
        },
        form: {
            typeResource: {
                placeHolder: "Sélectionner un type"
            }
        },
        advancedFilter: {
            placeholder: {
                human: "Filtrer les compétences",

                material: "Filtrer les caractéristiques"
            }
        }
    }
};